import actions from './remindPassFormActions';

import { EMAIL_PATTERN } from '../../lib/constants';
import auth from '../../services/auth';

const errorMessageInvalid = 'Перевірте правильність написання email';

export const onChangeEmail = (value) => {
    return (dispatch) => {
        const email = value.trim();
        dispatch({ type: actions.REMIND_PASS_FORM__CHANGE_EMAIL, email });
    };
};

export const onValidateEmail = () => {
    return (dispatch, getState) => {
        const {
            remindPassForm: { email },
        } = getState();
        const isInvalidEmail = !EMAIL_PATTERN.test(email);
        dispatch({
            type: actions.REMIND_PASS_FORM__VALIDATE,
            isInvalidEmail,
            errorMessage: errorMessageInvalid,
        });
    };
};

export const onSubmitForm = () => {
    return async (dispatch, getState) => {
        const {
            remindPassForm: { email, isInvalidEmail },
        } = getState();

        if (!isInvalidEmail) {
            dispatch({ type: actions.REMIND_PASS_FORM__SUBMIT });
            try {
                const resp = await auth.remindPass({ email });
                if (resp.status === 200) {
                    dispatch({
                        type: actions.REMIND_PASS_FORM__SHOW_SUCCESSFUL_MESSAGE,
                    });
                }
            } catch (err) {
                const errorMessage = err.message;
                dispatch({
                    type: actions.REMIND_PASS_FORM__SHOW_ERROR,
                    errorMessage,
                });
            }
        }
    };
};

export default {
    onChangeEmail,
    onSubmitForm,
    onValidateEmail,
};
